module.exports = __webpack_public_path__ + "img/pr-52.41dab8b4.png";